import React from "react";
import "./AccessLinkPageHeaderContent.scss";

import { ReactComponent as RequiredStar } from "src/images/required.svg";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import CustomImage from "src/app/components/CustomImage/CustomImage";
import { decodeRichText } from "src/app/Task/Comments/components/CommentText";

export function AccessLinkPageHeaderContent({
  caption,
  description,
  showLegend,
  logo,
  cover,
}) {
  return (
    <div className="access-link-page__header-content">
      {cover && (
        <CustomImage
          className="access-link-page__header-content__cover"
          src={cover}
          loading="lazy"
          alt="Recruitment form cover photo"
        />
      )}
      {(caption || logo) && (
        <div className="access-link-page__header-content__caption">
          {logo && (
            <CustomImage
              src={logo}
              loading="lazy"
              alt="Recruitment form logo photo"
              className="access-link-page__header-content__caption-logo"
            />
          )}
          {caption && (
            <h1 className="access-link-page__header-content__caption-title">
              {caption}
            </h1>
          )}
        </div>
      )}
      {description && (
        <div
          className="access-link-page__header-content__description"
          dangerouslySetInnerHTML={{
            __html: decodeRichText(description),
          }}
        />
      )}
      {showLegend && (
        <div className="access-link-page__header-content__legend">
          <RequiredStar />
          &nbsp;
          <IDHFormattedMessage id="ws_required" defaultMessage="Required" />
        </div>
      )}
    </div>
  );
}
